import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ExternalBankAccount,
  type ExternalBankAccountConstructor,
} from './ExternalBankAccount'
import { ExternalBankAccountTypes } from '../enums/ExternalBankAccountTypeEnum'

export const ExternalBankAccountConstructorFactory =
  Factory.Sync.makeFactory<ExternalBankAccountConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.finance.accountName()),
    currency: {
      id: 1,
      name: CurrencyNames.USD,
      rate: 1,
    },
    glCode: Factory.each(() => faker.random.alphaNumeric(6)),
    type: Factory.each(() =>
      faker.random.arrayElement([
        ExternalBankAccountTypes.OTHER,
        ExternalBankAccountTypes.CHECK,
        ExternalBankAccountTypes.ACH,
      ])
    ),
    data: {
      description: faker.lorem.sentence(),
    },
  }).withDerivation1(['type'], 'data', (type) => {
    switch (type) {
      case ExternalBankAccountTypes.OTHER:
      case ExternalBankAccountTypes.EFT:
      case ExternalBankAccountTypes.WIRE:
        return {
          description: faker.lorem.sentence(),
        }
      case ExternalBankAccountTypes.CHECK:
        return {
          startNumber: faker.random.number({ min: 1000, max: 9999 }).toString(),
        }
      case ExternalBankAccountTypes.ACH:
        return {
          bankName: faker.company.companyName(),
          bankRoutingNumber: faker.finance.account(9),
          companyName: faker.company.companyName(),
          companyRoutingNumber: faker.finance.account(9),
          companyTaxId: faker.finance.account(9),
        }
    }
  })

export const ExternalBankAccountFactory = EntityFactory(
  ExternalBankAccount,
  ExternalBankAccountConstructorFactory
)
